module.exports = __webpack_public_path__ + "static/media/no-video.21439ef1.jpg";